const url = '/vouchers';
const Provider = 'Vouchers';
const dbModel = 'Vouchers';

export { url, Provider, dbModel };
